import { Controller } from '@hotwired/stimulus'

export default class Select2Controller extends Controller {
  connect() {
    if (!$(this.element).is(':disabled')) {
      $(this.element).select2({
        minimumResultsForSearch: Infinity,
      });
    }

    $(this.element).on('select2:select', function (e) {
      this.dispatchEvent(new Event('change', { bubbles: true }));
    });
  }

  disconnect() {
    $(this.element).select2('destroy');
  }
}
